<script>
import baseMixins from '@/plans/ZOOM_MEETING/config/base';
import { mapGetters } from 'vuex';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import _, { get, groupBy } from 'lodash';
import audioUsCaMixin from '@/common/mixin/audio-us-ca-mixin';
import { bizCanDowngrade } from '../common/utils';
import { validDownSellLicenseForBiz2Pro } from '@/utils/validate-downsell';

export default {
  mixins: [baseMixins, audioUsCaMixin],
  data() {
    return {
      showPlanDetail: true
    };
  },
  computed: {
    ...mapGetters([
      'boughtPlans',
      'basicConfig',
      'disableMonthly2AnnualTip',
      'draftPlanFilterKeys', 
      'getSelectedPlans', 
      'assignInfo',
    ]),
    boughtZonePlan() {
      return this.boughtPlans.find((p) => p.type === planTypes.ZOOM_MEETING);
    },
    isSelectLargeMeeting() {
      return this.getSelectedPlans.find((p) => p.type === planTypes.LARGE_MEETING);
    },
    minHostAndReason() {
      const planGroupByType = groupBy(this.exceedBaseLicensePlans, 'type');
      const typeNames = Object.keys(planGroupByType).map(type => {
        const typeNameKey = get(planGroupByType[type], '0.typeNameKey', '');
        return this.$t(typeNameKey);
      }).filter(Boolean);
      const limits = [{
        minHost: this.formPlan ? this.formPlan.min : 1,
        reason: ''
      }, {
        minHost: this.maxAddonLicense,
        reason: this.$t('billing.licences_limit_tips', [typeNames.join(','), this.$t('billing.planform.title.zoom_meeting_zoomonenew')])
      }]
      if (this.isSelectLargeMeeting) {
        const { assignLicenseQuantity = 0 } = _.get(this.assignInfo, this.boughtZonePlan?.plan_code, {});
        limits.push({
          minHost: assignLicenseQuantity,
          reason: this.$t('billing.licenses_assigned_limit_tips')
        })
      }
      limits.sort((a, b) => b.minHost - a.minHost)
      return limits[0]
    },
    minHost() {
      return this.minHostAndReason.minHost
    },
    decreaseTips() {
      if (this.form.selectedNumber <= this.minHost) {
        return this.minHostAndReason.reason
      } else {
        return ''
      }
    },
    maxHostAndReason() {
      const defaultMaxHosts = 99;
      const boughtZonePlanQuantity = get(this.boughtZonePlan, 'cartInfo.selected_number', defaultMaxHosts);
      return {
        maxHost: boughtZonePlanQuantity + 99,
        reason: this.$t('billing.error.cant_add_100')
      }
    },
    maxHost() {
      return this.maxHostAndReason.maxHost
    },
    increaseTips() {
      if (this.form.selectedNumber >= this.maxHost) {
        return this.maxHostAndReason.reason
      } else {
        return ''
      }
    },
    showContinueWithLargeMeetingPromotion() {
      return !_.some(this.boughtPlans, (plan) => plan.type === planTypes.LARGE_MEETING) &&
      !_.some(this.draftPlanFilterKeys, (key) => key === 'LARGE_MEETING') &&
      !window.newBillingConfig?.hasPendingEventOfLM === true
    },
    isNormalCase() {
      return false
    },
    licenseTips() {
      if (this.needUnAssignTips) {
        return this.needUnAssignTips
      } else {
        return ''
      }
    },
    needUnAssignTips() {
      return validDownSellLicenseForBiz2Pro(this.form.selectedNumber, this.boughtZonePlan)?.errorMessage;
    },
  },
  watch: {
    minHost() {
      this.updatePlanLicense()
    },
    isSelectLargeMeeting(val) {
      if (val) {
        const { assignLicenseQuantity = 0 } = _.get(this.assignInfo, this.boughtZonePlan?.plan_code, {});
        if (this.form.selectedNumber < assignLicenseQuantity) {
          this.$message({
            message: this.$t('billing.zoom_one_biz.license_limit_with_lm'),
            duration: 10000
          })
        }
      }
    }
  },
  methods: {
    billingCycleDisabled({ billing_cycle }) {
      if (this.disableMonthly2AnnualTip && billing_cycle === BILLING_CYCLE.ANNUAL) {
        return this.disableMonthly2AnnualTip;
      }

      return this.getBillingCycleDisabledDesc(billing_cycle);
    },
    handleAddLargeMeeting() {
      this.$emit('add', 'LARGE_MEETING')
    },
  },
  mounted() {
    const btn = this.$el.querySelector('.opc-zmone__lm-promotion a')
    if (btn) {
      btn.addEventListener('click', this.handleAddLargeMeeting.bind(this))
      btn.setAttribute('role', 'button')
    }
    if (!bizCanDowngrade()) {
      window.location.href = '/billing'
    }
  }
};
</script>
